import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService
{
  public constructor(
    private readonly http: HttpClient,
  ) {
  }

  public subscribe(planName: string): Observable<{ url: string }>
  {
    return this.http.post<{ url: string }>(`${environment.apiUrl}/subscription`, {
      planName
    });
  }

  public subscribeWithFreeTrial(planName: string): Observable<{ subscriptionId: number, stripeSubscriptionId: string, plan: string }>
  {
    return this.http.post<{ subscriptionId: number, stripeSubscriptionId: string, plan: string }>(
      `${environment.apiUrl}/subscription/trial`, { planName }
    );
  }

  public getCustomerPortalLink(): Observable<{ url: string }> {
    return this.http.get<{ url: string }>(`${environment.apiUrl}/subscription/portal`);
  }
}
